import z from 'zod';
import { DocumentMetaTs, LocaleTs } from "../../common";
import { SingleTypes } from '@/providers/strapi';
import { ContentContext } from '../../content-provider';
import { useContext } from 'react';
import { OmitDocumentMeta } from '@/providers/strapi/client/types';
import { AdvantageCardSchema, EngaginCardSchema, HeroSchema, PromotionCardSchema, RetailerCustomerCardSchema, SatisfactionCardSchema, TravelerCardSchema } from '../components/retailer.component';
import { ratingCardTs, testimonialTs } from '../components/traveler.component';
import { BlogCardSchema, FaqSchema, SupportClientCardSchema } from '../components/shared.component';


export type RetailerHomePage = z.output<typeof RetailerHomePageTs>;
export const RetailerHomePageTs = DocumentMetaTs.extend({
  id: z.int(),
  locale: LocaleTs,
  localizations: z.array(DocumentMetaTs),
  hero: HeroSchema,
  satisfactionCard: SatisfactionCardSchema,
  travelerCard: TravelerCardSchema,
  advantagesCard: AdvantageCardSchema,
  engagingCard: EngaginCardSchema,
  promotionCard: PromotionCardSchema,
  retailerCustomerCard: RetailerCustomerCardSchema,
  ratingCard: ratingCardTs,
  testimonials: testimonialTs, //testimonialSlideTs.array(),
  faq: FaqSchema,
  blogCard: BlogCardSchema,
  supportClientCard: SupportClientCardSchema
})

export const RETAILER = "retailer";
export function useRetailerHomePage<
  K extends keyof Omit<RetailerHomePage, "id" | "locale" | "localizations" | OmitDocumentMeta>
>(
  entity: K,
  // contextKey: string
): RetailerHomePage[K] {
  const content: Record<string, SingleTypes> | null = useContext(ContentContext);
  if (!content) throw new Error(`RetailerHomePage content not found`)
  const retailerHomePage = content[RETAILER] as RetailerHomePage;
  if (!retailerHomePage || !retailerHomePage[entity]) throw new Error(`${entity} content not found`)
  return retailerHomePage[entity]
}
